export default __webpack_public_path__ + "static/media/help.2e1c55ed.svg";